export default "__VITE_ASSET__2b5f5dc2__"